"use client"

import Header from "../../components/Header/Header"
import Footer from "../../components/Footer/Footer"
import styles from "./PatientGuidePage.module.css"
import beforeOp from "../../assets/images/PatientGuide/flight-customer-2.png"
import procedure from "../../assets/images/PatientGuide/Procedure-Day.jpeg"
import afterOp from "../../assets/images/PatientGuide/after-smiley.jpg"
import operations from "../../assets/images/PatientGuide/patient-img.png"

export default function PatientGuidePage() {
  return (
    <>
      <Header />

      <main className={styles.pageMain}>
        <div className={styles.container}>
          <h1 className={styles.heroTitle}>Your Patient Journey Handbook</h1>
          <p className={styles.heroDesc}>
            You are cared for by a seasoned team of specialists, dedicated to providing personalized treatment plans with your comfort and well-being as our top priority.
          </p>
        </div>

        <div className={styles.ctaStrip}>
          <div className={styles.ctaInner}>
            <div className={styles.ctaCard}>
              Before Coming
              <div className={styles.ctaUnderline} />
            </div>
          </div>
        </div>

        {/* Steps / Before-After Section */}
        <section className={styles.stepsSection}>
          <div className={styles.stepsContainer}>
            <div>
              <div className={styles.leftImageCard}>
                <img src={operations} alt="Patients" className={styles.leftImage} />
              </div>
              <div className={styles.leftNoteBox}>
                Helping us prepare for your procedure starts with sharing your medical history. Please be ready to talk about the following points at your appointment.
              </div>
              <div className={styles.leftList}>
                <a href="#">For a Smooth Recovery: Key Precautions</a>
                <a href="#">Discontinue blood-thinning medications (as advised by your doctor).</a>
                <a href="#">Refrain from alcohol, smoking, and caffeine consumption, as they can interfere with healing and anesthesia.</a>
              </div>
            </div>

            <div className={styles.rightSteps}>
              <div className={styles.stepItem}>
                <div className={styles.stepThumb}><img src={beforeOp} alt="Before operation" /></div>
                <div className={styles.stepContent}>
                  <h4>Your Pre-Arrival Coordination</h4>
                  <p>Once you share your flight details, your dedicated patient coordinator will arrange your hotel stay and airport transfers, ensuring a seamless arrival. All confirmations and details will be sent directly to you via WhatsApp or email.</p>
                </div>
              </div>

              <div className={styles.stepItem}>
                <div className={styles.stepThumb}><img src={procedure} alt="Procedure day" /></div>
                <div className={styles.stepContent}>
                  <h4>The Day of Your Care</h4>
                  <p>On the day of your procedure, our driver will pick you up from your hotel and bring you comfortably to the hospital. There, you will meet your surgeon for a final consultation and pre-operative assessment to ensure everything is ready.</p>
                </div>
              </div>

              <div className={styles.stepItem}>
                <div className={styles.stepThumb}><img src={afterOp} alt="After operation" /></div>
                <div className={styles.stepContent}>
                  <h4>Post-Procedure & Healing</h4>
                  <p>Following your procedure, you will be monitored as you recover. Once your surgeon approves your discharge, we will handle all the necessary formalities. You will receive clear aftercare instructions and a detailed explanation of any prescribed medications before you leave.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      
        {/* Don't Forget Before Coming Section */}
        <section className={styles.forgetSection}>
          <div className={styles.forgetInner}>
            <h2 className={styles.forgetTitle}>For a Seamless Experience</h2>
            <p className={styles.forgetSubtitle}>Your journey with us is tailored to your unique needs from the very start. To help us create your personalized treatment plan, please ensure we have all the necessary information. Our expert team is committed to your comfort and exceptional results.</p>

            <div className={styles.forgetGrid}>
              <div className={styles.forgetItem}>
                <div className={styles.forgetIconWrap} aria-hidden>
                  {/* Money bag SVG */}
                  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M32 6c4 0 7 3 7 7v2h10v6c0 6-6 12-10 12H17c-4 0-10-6-10-12V15h10v-2c0-4 3-7 7-7z" fill="#F6C156"/>
                    <path d="M28 34c2 2 8 2 10 0" stroke="#C47B2A" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <div>
                  <h3 className={styles.forgetHeading}>Payment Options & Information</h3>
                  <p className={styles.forgetText}>To simplify your transaction, we recommend cash payments to avoid potential international bank fees. If you prefer to pay by credit card, please ensure it is authorized for international transactions to prevent any delays.</p>
                </div>
              </div>

              <div className={styles.forgetItem}>
                <div className={styles.forgetIconWrap} aria-hidden>
                  {/* Plane SVG */}
                  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 34l60-20-18 22 18 8-22 6-6-8L2 34z" fill="#9BBCE8"/>
                  </svg>
                </div>
                <div>
                  <h3 className={styles.forgetHeading}>Flight Itinerary Update</h3>
                  <p className={styles.forgetText}>To ensure a seamless pick-up and transfer service, please notify your patient coordinator immediately of any changes to your flight itinerary.</p>
                </div>
              </div>

              <div className={styles.forgetItem}>
                <div className={styles.forgetIconWrap} aria-hidden>
                  {/* Pill SVG */}
                  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                    <rect x="6" y="18" width="52" height="28" rx="14" fill="#E6F0FF"/>
                    <path d="M18 18l28 28" stroke="#5B8BD6" strokeWidth="4" strokeLinecap="round"/>
                  </svg>
                </div>
                <div>
                  <h3 className={styles.forgetHeading}>Personal Medications</h3>
                  <p className={styles.forgetText}>Please remember to bring an adequate supply of your regular medications in their original packaging for the duration of your stay.</p>
                </div>
              </div>

              <div className={styles.forgetItem}>
                <div className={styles.forgetIconWrap} aria-hidden>
                  {/* Document SVG */}
                  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
                    <rect x="10" y="8" width="44" height="48" rx="4" fill="#EAF2FF"/>
                    <path d="M18 20h28M18 28h28M18 36h18" stroke="#7FA6E8" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <div>
                  <h3 className={styles.forgetHeading}>Arrival Instructions</h3>
                  <p className={styles.forgetText}>For a smooth airport meet-and-greet, please save the pick-up details and visual guide sent by your coordinator to your mobile device for offline access.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}
